import { Card, Flex, Form, Layout, Spin, Typography } from 'antd';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import iconTitle from '../../assets/images/schedules/icon-price-setting.svg';
import '../../assets/styles/scheduleSetting.scss';
import StepSchedules from '../../components/StepSchedules';
import { Constant } from '../../config/constant';
import { useAppDispatch, useAppSelector } from '../../redux/hooks';
import { fetchListPickupLocation } from '../../redux/slice/pickupLocationSlice';
import { fetchListRoute } from '../../redux/slice/routeSlice';
import { createScheduleSelector, createScheduleV2 } from '../../redux/slice/schdules/createSchedule';
import { ListScheduleSelector, setResetLoadSchedule } from '../../redux/slice/schdules/scheduleSlice';
import { updateScheduleSelector, updateScheduleV2 } from '../../redux/slice/schdules/updateSchedule';
import SegmentRenderer from './SegmentRender';
import { toast } from 'react-toastify';

export enum ScheduleType {
  specific_date = 'specific_date',
  daily = 'daily',
  weekly = 'weekly',
  monthly = 'monthly',
  days = 'days',
}

function SettingPrice() {
  const dispatch = useAppDispatch();
  const { listSegment, agent_seats, listTransships, fares, locks, dataSchedule, listScheduleDetail, isDetailSchedule } =
    useAppSelector(ListScheduleSelector);
  const { loading: loadingCreate, status: statusCreate } = useAppSelector(createScheduleSelector);
  const { status: statusUpdate, loading: loadingUpdate } = useAppSelector(updateScheduleSelector);
  const [form] = Form.useForm();
  const navigate = useNavigate();

  const scrollToErrorField = (errorFields: any) => {
    const [firstErrorField] = errorFields;
    if (firstErrorField) {
      form.scrollToField(firstErrorField.name);
    }
  };
  const onFinish = (values: any) => {
    if (fares?.length) {
      const scheduleParams = {
        id: isDetailSchedule ? listScheduleDetail?.id : undefined,
        contract_value: dataSchedule?.contract_value ? dataSchedule?.contract_value : undefined,
        route_id: listSegment?.route_id,
        bus_type_id: listSegment?.bus_type_id,
        open_before: dataSchedule?.open_before,
        close_before_hour: dataSchedule?.close_before_hour,
        close_before_type: dataSchedule?.close_before_type,
        driver_id: dataSchedule?.driver_id,
        extra_driver_id: dataSchedule?.extra_driver_id,
        bus_id: dataSchedule?.bus_id,
        reservation_type: dataSchedule?.reservation_type,
        close_before: dataSchedule?.close_before,
        frequency_type: dataSchedule?.frequency_type,
        frequency_value: dataSchedule?.frequency_value,
        reservation_hour: dataSchedule?.reservation_hour,
        reservation_minute: dataSchedule?.reservation_minute,
        auto_operated: dataSchedule?.auto_operated,
        depart_time: listSegment?.depart_time,
        arrive_time: listSegment?.arrive_time,
        travel_time: listSegment?.travel_time,
        is_depart_transship: listSegment?.is_depart_transship ? true : false,
        is_arrive_transship: listSegment?.is_arrive_transship ? true : false,
        agent_seats: agent_seats,
        is_online: dataSchedule?.is_online ? true : false,
        pay_later: dataSchedule?.pay_later ? true : false,
        is_diagram: dataSchedule?.is_diagram ? true : false,
        is_diagram_openapi: dataSchedule?.is_diagram_openapi ? true : false,
        is_online_company: dataSchedule?.is_online_company ? true : false,
        is_diagram_company: dataSchedule?.is_diagram_company ? true : false,
        is_contract: dataSchedule?.is_contract ? true : false,
        segments: listSegment?.segment,
        transships: listTransships,
        fares: fares,
        locks: locks,
      };
      if (isDetailSchedule) {
        dispatch(updateScheduleV2(scheduleParams));
      } else {
        dispatch(createScheduleV2(scheduleParams));
      }
    } else {
      toast.error('Vui lòng nhập giá vé');
    }
  };
  useEffect(() => {
    dispatch(fetchListRoute({}));
  }, [dispatch]);

  useEffect(() => {
    dispatch(fetchListPickupLocation({}));
  }, [dispatch]);
  useEffect(() => {
    if (statusCreate === Constant.DEFAULT_STATUS) {
      navigate('/bus-management/schedules');
      dispatch(setResetLoadSchedule());
    }
  }, [statusCreate, dispatch, navigate]);

  useEffect(() => {
    if (statusUpdate === Constant.DEFAULT_STATUS) {
      navigate('/bus-management/schedules');
      dispatch(setResetLoadSchedule());
    }
  }, [statusUpdate, dispatch, navigate]);
  return (
    <Layout className="min-vh-70 segment-booking schedule schedule-modal">
      <Spin spinning={loadingCreate || loadingUpdate}>
        <Card>
          <Form
            layout="vertical"
            form={form}
            onFinish={onFinish}
            autoComplete="off"
            validateTrigger="onSubmit"
            name="segment-setting-form"
            colon={false}
            labelCol={{ span: 12 }}
            labelAlign={'left'}
            labelWrap
            onFieldsChange={(allFields) => {
              scrollToErrorField(allFields.filter((field) => field.errors && field.errors.length > 0));
            }}
          >
            <StepSchedules step={5} loadingCreate={loadingCreate} loadingUpdate={loadingUpdate} />
            <div className="segment-block price">
              <div className="mt-4 border-b-segment pb-3">
                <Flex gap={16}>
                  <img src={iconTitle} alt="" />
                  <div>
                    <Typography.Text className="fw-600 fs-18 title-segment">Thiết lập giá vé</Typography.Text> <br />
                    <Typography.Text className="fw-500 fs-16" style={{ color: '#4F5662' }}>{`Tuyến: ${
                      listSegment?.depart_point ?? ''
                    } - ${listSegment?.arrive_point ?? ''}, Giờ đi: ${listSegment?.depart_time}`}</Typography.Text>
                  </div>
                </Flex>
              </div>
              <div className="agent-seat-content mt-4 w-fit"></div>
            </div>
          </Form>
          <SegmentRenderer
            listSegment={listSegment}
            listTransships={listTransships}
            fares={fares}
            locks={locks}
            isDetailSchedule={isDetailSchedule}
            listScheduleDetail={listScheduleDetail}
            dataSchedule={dataSchedule}
          />
        </Card>
      </Spin>
    </Layout>
  );
}

export default SettingPrice;
